import ConfirmModal from 'components/UI/ConfirmPopup.js';
import { usePerms } from 'contexts/PermsContext.js';
import { selectVisibleDeviceTypes } from 'features/integrations/state/selectors/integrationSelectors';
import { setSelectedDevice } from 'features/integrations/state/thunks/deviceThunks.js';
import { canViewDeviceType } from 'features/integrations/utils/integrationVisibilityUtils.js';
import { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectUsgsProvisonalAccepted,
  setUsgsProvisonalAccepted,
} from '../../../../store/slices/Widget/widgetSlice.js';
import { selectUpdatedSelectedDevice } from '../../state/selectors/deviceSelectors.js';
import { USGS_PROVISIONAL_STATEMENT } from './assets/USGSProvisionalStatment.js';
import './assets/connectedDevices.css';
import DeviceGraph from './features/DeviceGraph/index.web.jsx';
import DeviceList from './features/DeviceList/index.web.jsx';
import DeviceMap from './features/DeviceMap/index.web.jsx';

export default function ConnectedDevices({
  showCurrentDevice,
  setShowCurrentDevice,
  startTime,
  endTime,
  selectedGroup,
  setShowDeviceSettings,
  setSelectedGroup,
  setStartTime,
  setEndTime,
}) {
  const updatedSelectedDevice = useSelector(selectUpdatedSelectedDevice);
  const dispatch = useDispatch();
  const visibleDeviceTypes = useSelector(selectVisibleDeviceTypes);
  // provisionalAccepted is the single source of truth (Redux global).
  // showDisclaimerModal is only for explicit manual re-opens; the modal auto-shows
  // via !provisionalAccepted without needing to mirror that value in local state.
  const provisionalAccepted = useSelector(selectUsgsProvisonalAccepted);
  const [showDisclaimerModal, setShowDisclaimerModal] = useState(false);
  const perms = usePerms();

  const renderGraph = () => {
    const canViewAware = canViewDeviceType(
      {
        system_type: 'Flood',
      },
      perms,
      visibleDeviceTypes,
    );

    if (!canViewAware) {
      return (
        <div className="d-flex flex-fill align-items-center justify-content-center text-center">
          Select a Device
        </div>
      );
    }

    return (
      <DeviceGraph
        startTime={startTime}
        endTime={endTime}
        setShowCurrentDevice={setShowCurrentDevice}
        setShowProvisional={setShowDisclaimerModal}
      />
    );
  };

  return (
    <Row className="g-md-3 gap-3 gap-md-0 flex-md-nowrap flex-grow-1 min-h-0 h-100">
      <Col xs={12} md={7} className="d-flex flex-column min-h-0">
        <div className="connected-devices-left d-flex flex-column flex-grow-1 min-h-0 gap-3">
          <div className="connected-devices-panel d-flex flex-column min-h-sm">
            <DeviceMap
              setShowCurrentDevice={setShowCurrentDevice}
              setShowDeviceSettings={setShowDeviceSettings}
              selectedGroup={selectedGroup}
              setSelectedGroup={setSelectedGroup}
              setShowProvisional={setShowDisclaimerModal}
              usgsMapWidget
            />
          </div>
          <ConfirmModal
            open={!provisionalAccepted || showDisclaimerModal}
            setOpen={setShowDisclaimerModal}
            options={['Continue']}
            callbacks={[
              () => {
                dispatch(setUsgsProvisonalAccepted(true));
                setShowDisclaimerModal(false);
              },
            ]}
            message={USGS_PROVISIONAL_STATEMENT}
            closeAction={() => {}}
            size="lg"
          />
          <div className="connected-devices-panel connected-devices-graph d-flex flex-column flex-grow-1 flex-basis-0">
            {renderGraph()}
          </div>
        </div>
      </Col>
      <Col xs={12} md={5} className="d-flex flex-column">
        <div className="flex-grow-1 overflow-hidden max-h-fit">
          <DeviceList
            updateSelectedDevice={updatedSelectedDevice}
            setStartTime={setStartTime}
            setEndTime={setEndTime}
            showCurrentDevice={showCurrentDevice}
            setShowCurrentDevice={setShowCurrentDevice}
            onSelectedDeviceIndex={(index) => dispatch(setSelectedDevice({ index: index }))}
          />
        </div>
      </Col>
    </Row>
  );
}
